export default "__VITE_ASSET__BO_WaH62__"